module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "staapprCount-button"
    }
  }, [(_vm.disable) ? [_c('div', {
    staticClass: "sta-disable"
  }, [(_vm.staappr === 'P') ? _c('div', {
    staticClass: "sta-disable text-gray"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch icon-status"
  }), _vm._v("Pending")]) : _vm._e(), _vm._v(" "), (_vm.staappr === 'A') ? _c('div', {
    staticClass: "sta-disable text-blue"
  }, [_c('i', {
    staticClass: "fa fa-check icon-status"
  }), _vm._v("Approving")]) : _vm._e(), _vm._v(" "), (_vm.staappr === 'Y') ? _c('div', {
    staticClass: "sta-disable text-green"
  }, [_c('i', {
    staticClass: "fa fa-check-circle icon-status"
  }), _vm._v("Approved")]) : _vm._e(), _vm._v(" "), (_vm.staappr === 'C') ? _c('div', {
    staticClass: "sta-disable text-gray-dark"
  }, [_c('i', {
    staticClass: "fa fa-close icon-status"
  }), _vm._v("Canceled")]) : _vm._e(), _vm._v(" "), (_vm.staappr === 'N') ? _c('div', {
    staticClass: "sta-disable text-red"
  }, [_c('i', {
    staticClass: "fa fa-ban icon-status"
  }), _vm._v("Rejected")]) : _vm._e()])] : [_c('div', {
    staticClass: "cursor-pointer",
    class: [_vm.flgStaapprCount == 0 ? 'sta-none' : _vm.flgStaapprCount == 1 ? 'sta-approve' : 'sta-reject'],
    on: {
      "click": function($event) {
        _vm.countStaappr()
      }
    }
  }, [_c('i', {
    staticClass: "icon-status",
    class: 'fa fa-' + [_vm.flgStaapprCount == 0 ? 'circle-o-notch' : _vm.flgStaapprCount == 1 ? 'check-circle' : 'ban']
  }), _vm._v(_vm._s(_vm.status) + "\n    ")])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b8607cf6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrmsTableTemplate/staapprButton.vue
// module id = 3961
// module chunks = 1